// CAT-510 — PTFW V3 intent capture.
//
// Option titles are owned by the backend (`options[].title` on
// `GET /api/c/creatorIntent/getState/`) so copy can change without a web
// deploy. This file only owns what the API does not send: the leading icon
// per option key, and the static screen copy.

export const INTENT_KEYS = {
  BRAND_DEALS: "brand_deals",
  EARN_FROM_EXISTING_POSTS: "earn_from_existing_posts",
  AUTO_DM_ON_COMMENTS: "auto_dm_on_comments",
};

// Figma 148:19796 — leading icons on the three option cards.
export const INTENT_ICONS = {
  [INTENT_KEYS.BRAND_DEALS]: "fa-solid fa-handshake",
  [INTENT_KEYS.EARN_FROM_EXISTING_POSTS]: "fa-solid fa-indian-rupee-sign",
  [INTENT_KEYS.AUTO_DM_ON_COMMENTS]: "fa-solid fa-comment-dots",
};

// Used when the backend ships a new option key before the web deploy that
// knows its icon — the card still renders rather than showing an empty square.
export const INTENT_FALLBACK_ICON = "fa-solid fa-wand-magic-sparkles";

export const getIntentIcon = (key) => INTENT_ICONS[key] || INTENT_FALLBACK_ICON;

export const INTENT_COPY = {
  HEADING: "What brings you to Wishlink?",
  SUBTITLE:
    "Your app experience stays the same, this just helps us guide you better.",
  CTA: "Continue",
  ERROR: "Something went wrong. Please try again.",
  RETRY: "Retry",
};

export const INTENT_CAPTURE_PAGE = "intent_capture";
